function closeSideDrawer() {
	// Close all pre-rendered drawers.
	document.querySelectorAll(".drawer[data-drawer]").forEach(d => d.classList.remove("drawer--open"))
	document.body.classList.remove("drawer-open")
}

// Function to open side drawers based on drawer type (pre-rendered, no JS DOM creation)
function openSideDrawer(drawerType) {
	const drawer = document.querySelector(`.drawer[data-drawer="${drawerType}"]`)
	if (!drawer) return

	closeSideDrawer()
	drawer.classList.add("drawer--open")
	document.body.classList.add("drawer-open")
}

// Expose globally for inline `onclick="openSideDrawer(...)"` usage.
if (typeof window !== "undefined") {
	window.openSideDrawer = openSideDrawer
	window.closeSideDrawer = closeSideDrawer
}

const TYPE_PICKER_PAGE_LOADING_ID = "type-picker-page-loading-overlay"

function setTypePickerPageLoading(active) {
	const body = document.body
	if (!active) {
		body.classList.remove("type-picker-page-loading")
		const el = document.getElementById(TYPE_PICKER_PAGE_LOADING_ID)
		if (el) el.hidden = true
		return
	}
	let el = document.getElementById(TYPE_PICKER_PAGE_LOADING_ID)
	if (!el) {
		el = document.createElement("div")
		el.id = TYPE_PICKER_PAGE_LOADING_ID
		el.className = "type-picker-page-loading-overlay"
		el.setAttribute("role", "status")
		el.setAttribute("aria-live", "polite")
		el.innerHTML =
			'<span class="sr-only">Loading product</span><div class="type-picker-page-loading-overlay__spinner" aria-hidden="true"></div>'
		document.body.appendChild(el)
	}
	el.hidden = false
	body.classList.add("type-picker-page-loading")
	closeSideDrawer()
}

class TypePicker extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.addEventListener("click", async (e) => {
			const sectionUrl = this.getAttribute("data-section-url");
			let sectionId = this.getAttribute("data-section-id");
			if (!sectionId) {
				const sec = this.closest(".shopify-section")
				if (sec?.id) sectionId = sec.id.replace("shopify-section-", "")
			}

			// Fabric / product-sibling picker: replace the whole main product section (Section Rendering API)
			if (sectionUrl && sectionId) {
				e.preventDefault()
				const targetUrl = new URL(sectionUrl, window.location.origin)
				if (targetUrl.pathname === window.location.pathname) return

				const shopifySection = document.getElementById(`shopify-section-${sectionId}`)
				if (!shopifySection) return

				setTypePickerPageLoading(true)
				shopifySection.classList.add("is-loading")
				const fetchUrl = new URL(sectionUrl, window.location.origin)
				fetchUrl.searchParams.set("section_id", sectionId)

				try {
					const res = await fetch(fetchUrl.toString())
					if (!res.ok) return
					const html = await res.text()
					const doc = new DOMParser().parseFromString(html, "text/html")
					const incoming =
						doc.getElementById(`shopify-section-${sectionId}`) ||
						doc.querySelector(".shopify-section")
					if (!incoming) return

					shopifySection.replaceChildren(
						...document.importNode(incoming, true).childNodes
					)
					targetUrl.searchParams.delete("section_id")
					history.pushState({}, "", targetUrl.toString())
					const h1 = shopifySection.querySelector("h1")
					if (h1?.textContent) document.title = h1.textContent.trim()
				} catch (err) {
					console.error("Failed to fetch product section:", err)
				} finally {
					shopifySection.classList.remove("is-loading")
					setTypePickerPageLoading(false)
				}
				return
			}
		})
	}
}

window.customElements.define("type-picker", TypePicker)

class ProductTab extends HTMLElement {
	constructor() {
		super()
	}
	connectedCallback() {
		if (this.getAttribute("type") === "reviews") {
			const jdgmWidget = this.querySelector(".jdgm-prev-badge")
			if (jdgmWidget) {
				this.querySelector(
					".jdgm-prev-badge__rating"
				).textContent = `Reviews: ${jdgmWidget.getAttribute("data-average-rating")}`
				const count = jdgmWidget.getAttribute("data-number-of-reviews")
				if (Number(count) === 0) {
					this.classList.add("no-reviews")
					document.querySelectorAll("#judgeme_product_reviews").forEach(r => {
						if (r.closest(".shopify-section--apps"))
							r.closest(".shopify-section--apps").classList.add("hidden")
					})
					this.querySelector(
						".jdgm-prev-badge__rating"
					).textContent = `No reviews`
				}
				document.querySelectorAll(".jdgm-prev-badge__count").forEach(r => {
					if (Number(count) !== 0) r.textContent = `(${count})`
				})
			}
		}
		this.addEventListener("click", () => {
			openSideDrawer(this.getAttribute("type"))
		})
	}
}
window.customElements.define("product-tab", ProductTab)

class MoreToggle extends HTMLElement {
	constructor() {
		super()
		this.open = false
	}
	connectedCallback() {
		this.addEventListener("click", () => {
			this.previousElementSibling.classList.toggle("truncate")
			this.open = !this.open
			this.textContent = this.open ? "... less" : "... more"
		})
	}
}
window.customElements.define("more-toggle", MoreToggle)

class FabricTypeToggle extends HTMLElement {
	constructor() {
		super()
		this.expanded = false
	}

	connectedCallback() {
		if (this.dataset.initialized === "true") return
		this.dataset.initialized = "true"

		this.list = this.previousElementSibling
		if (!this.list) return

		this.moreText = this.getAttribute("data-more-text") || "Show more"
		this.lessText = this.getAttribute("data-less-text") || "Show less"

		this.setAttribute("role", "button")
		this.setAttribute("tabindex", "0")
		this.textContent = this.moreText

		this.addEventListener("click", this.toggle.bind(this))
		this.addEventListener("keydown", e => {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault()
				this.toggle()
			}
		})
	}

	toggle() {
		this.expanded = !this.expanded
		this.list.classList.toggle("is-collapsed", !this.expanded)
		this.textContent = this.expanded ? this.lessText : this.moreText
	}
}
window.customElements.define("fabric-type-toggle", FabricTypeToggle)

const headerGrp = document.querySelector(".header-grp-sticky")
let lastScrollY = window.scrollY
window.addEventListener("scroll", e => {
	const currentScrollY = window.scrollY
	if (currentScrollY > headerGrp.clientHeight) {
		if (currentScrollY > lastScrollY) {
			headerGrp.classList.add("hide-header")
		} else if (currentScrollY < lastScrollY) {
			headerGrp.classList.remove("hide-header")
		}
	} else {
		headerGrp.classList.remove("hide-header")
	}

	lastScrollY = currentScrollY
})
const injectStyles = () => {
	const el = document.querySelector("inbox-online-store-chat")

	// 1. Check if the element exists and HAS a shadowRoot
	if (el && el.shadowRoot) {
		// 2. Check if the internal content (.chat-title) actually exists yet
		const target = el.shadowRoot.querySelector(".chat-app")
		console.log("injject", target)

		if (target) {
			console.log("target")

			const style = document.createElement("style")
			style.textContent = `
		
        .chat-title { display: none !important; }
				button.chat-toggle.chat-toggle--text-button,
				button.chat-toggle.chat-toggle--icon-button {
				    width: 44px!important;
    height: 44px!important;
    padding: 0!important;
    margin: 0!important;
    max-width: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
		background: #F1B00B!important;
		  
				}
.chat-app.chat-app-- {
    display: flex;
		flex-direction: column;
    justify-content: end;
    align-items: end;
		max-width: 376px;
    margin-left: auto;
		pointer-events: all;
		width: fit-content;
		&.chat-app--is-mobile {
    margin-left: auto;
    margin-right: 12px;
	}
}
	.chat-app--is-open:not(.chat-app--is-mobile) {
	margin-right: 0px;}
	.chat-toggle:after {
	    translate: 0 2px;}
			.chat-app.chat-app--is-open {
		pointer-events: all;
		}
		.chat-app .chat-app--close-button-bottom-right {
    margin-left: auto;
		width: 44px;
    height: 44px;
    margin: 10px 0;
}
				button.chat-toggle {
					background: #F1B00B!important;
					} 
				

        .chat-toggle svg { display: none !important; }
				.chat-toggle:after {
				content: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.45455 16L0 19.5V1C0 0.44772 0.44772 0 1 0H19C19.5523 0 20 0.44772 20 1V15C20 15.5523 19.5523 16 19 16H4.45455ZM3.76282 14H18V2H2V15.3851L3.76282 14ZM9 7H11V9H9V7ZM5 7H7V9H5V7ZM13 7H15V9H13V7Z" fill="%23141311"/></svg>');
				}
      `
			el.shadowRoot.appendChild(style)
			const idChatApp = document.getElementById("shopify-chat")
			if (idChatApp) idChatApp.classList.add("loaded")
			console.log("Styles successfully injected!")
			return true // Success!
		}
	}
	return false // Not ready yet
}

// Use an interval to "poll" until the widget is fully rendered
const poll = setInterval(() => {
	if (injectStyles()) {
		clearInterval(poll) // Stop once successful
	}
}, 500) // Check every 0.5 seconds

// Safety: Stop trying after 10 seconds so it doesn't run forever
setTimeout(() => clearInterval(poll), 10000)

const jdgmReviews = document.querySelectorAll(".jdgm-review-widget")

setTimeout(() => {
	jdgmReviews.forEach(el => {
		const wrapper = el.querySelector(".jdgm-rev-widg")
		if (!wrapper) return
		const avarage = el.querySelector(".jdgm-rev-widg__summary-average")
		const data_avarage = wrapper.getAttribute("data-average-rating")
		if (avarage && data_avarage) {
			avarage.textContent = data_avarage
			const clone = avarage.cloneNode(true)
			const inner = el.querySelector(".jdgm-rev-widg__summary-inner")
			if (inner) inner.appendChild(clone)
		}
	})
}, 500)
